<template>
  <!-- 如何偿还 -->
  <div class="container">
    <!-- 顶部导航栏 -->
    <HeadTab :typeindex="2" isshow="1"></HeadTab>
    <!-- <img class="opl" src="/static/img/Mask_group.png" alt="" /> -->
    <div class="obtain">
      <div class="tutorial_inner">
        <div class="tutorial_left">
          <div class="obtain_title">Как погасить <span>МИКРОКРЕДИТ?</span></div>
          <div class="tutorial_card">
            <div class="bvc">
              <img class="nbf" src="/static/img/Container8.png" alt="" />
              <div class="tutorial_card-title">PAYMENT PROCESS DESCRIPTION</div>
            </div>
            <div class="tutorial_item">
              <div class="tutorial_num">1</div>
              <div class="tutorial_content">
                <div class="tutorial_text tutorial_text-strong">Процесс оплаты:</div>
                <div class="tutorial_bullet">Оплата производится банковской картой VISA/MasterCard через онлайн-платёжную платформу.</div>
                <div class="tutorial_bullet">Выберите сумму платежа и нажмите кнопку <span class="oig">«Оплатить»</span>.</div>
                <div class="tutorial_bullet">На странице оплаты введите: номер банковской карты; имя держателя карты; срок действия карты;</div>
                <div class="tutorial_bullet">трёхзначный код безопасности (CVV/CVC).</div>
                <div class="tutorial_bullet">Банк отправит вам SMS-код подтверждения. После ввода правильного кода вы перейдёте к следующему шагу и успешно завершите оплату.</div>
              </div>
            </div>
            <div class="tutorial_item tutorial_item-last">
              <div class="tutorial_num">2</div>
              <div class="tutorial_text">Если у вас возникли проблемы в процессе оплаты, пожалуйста, свяжитесь с нами по электронной почте: <span>info@mfofinancesolutions.kz</span></div>
            </div>
          </div>
        </div>
        <!-- 额度信息 -->
        <div class="tutorial_right">
          <LoanCard :bgindex="2"></LoanCard>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <BomTab :jumpindex="0"></BomTab>
  </div>
</template>

<script>
  import HeadTab from '@/components/HeadTab.vue'
  import BomTab from '@/components/BomTab.vue'
  import LoanCard from '@/components/loancard.vue'
  export default {
    name: "tutorial",
    data() {
      return {

      };
    },
    components: {
      BomTab,
      HeadTab,
      LoanCard
    },
    mounted () {
    },
    methods: {},
  };
</script>

<style scoped>
  .opl{
    width: 3.29rem;
    height: 1.82rem;
    position: absolute;
    top: 0.57rem;
    left: 0;
  }
  .obtain {
    background: #FFF8F6;
    padding: 0.78rem 1.58rem 1.29rem;
  }
  .tutorial_inner {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.58rem;
  }
  .tutorial_left {
    width: 3.48rem;
  }
  .obtain_title {
    width: 3.32rem;
    color: #271814;
    font-family: Inter, Inter;
    font-weight: 900;
    font-size: 0.31rem;
    margin-bottom: 0.13rem;
  }
  .obtain_title span {
    color: #B62404;
  }
  .tutorial_title {
    color: rgba(51, 51, 51, 1);
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.21rem;
    margin-bottom: 0.17rem;
  }
  .tutorial_card {
    background: #FFFFFF;
    box-shadow: 0rem 0.01rem 0.01rem 0rem rgba(0,0,0,0.05);
    border-radius: 0.06rem;
    border: 0.01rem solid #FFE2DC;
    padding: 0.13rem;
  }
  .bvc{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.25rem;
  }
  .nbf{
    width: 0.14rem;
    height: 0.1rem;
    margin-right: 0.06rem;
  }
  .tutorial_card-title {
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 0.06rem;
    color: #B62404;
    line-height: 0.08rem;
    font-style: normal;
  }
  .tutorial_item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 0.08rem;
  }
  .tutorial_item-last {
    margin-bottom: 0;
  }
  .tutorial_num {
    width: 0.21rem;
    height: 0.21rem;
    line-height: 0.21rem;
    background: #FC8C74;
    border-radius: 52.08rem;
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 0.08rem;
    color: #742414;
    text-align: center;
    font-style: normal;
    margin-right: 0.13rem;
  }
  .tutorial_content {
    flex: 1;
  }
  .tutorial_text {
    width: 2.4rem;
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 0.09rem;
    color: #333333;
    line-height: 0.15rem;
    text-align: left;
    font-style: normal;
  }
  .tutorial_text-strong {
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    text-align: left;
    font-style: normal;
    margin-bottom: 0.13rem;
  }
  .tutorial_text span {
    color: #00687B;
  }
  .tutorial_bullet {
    position: relative;
    padding-left: 0.08rem;
    margin-bottom: 0.13rem;
    color: #5B403B;
    font-family: Montserrat;
    font-weight: 400;
    font-size: 0.08rem;
    line-height: 0.13rem;
  }
  .tutorial_bullet::before {
    content: '';
    width: 0.03rem;
    height: 0.03rem;
    border-radius: 50%;
    background: #009FBB;
    position: absolute;
    top: 0.06rem;
    left: 0;
  }
  .oig{
    color: #FF5836;
  }
  .tutorial_bullet:last-child {
    margin-bottom: 0;
  }

  @media screen and (max-width: 1200px) {
    .obtain {
      padding-left: 0.4rem;
      padding-right: 0.4rem;
    }
    .tutorial_inner {
      gap: 0.24rem;
    }
    .tutorial_left,
    .tutorial_right {
      width: 50%;
    }
  }

  @media screen and (max-width: 768px) {
    .opl{
      width: 2.29rem;
      height: 1.32rem;
      position: absolute;
      top: 0.95rem;
      left: 0;
    }
    .obtain {
      padding-top: 0.42rem;
      padding-bottom: 0.48rem;
    }
    .tutorial_inner {
      flex-direction: column;
    }
    .tutorial_left,
    .tutorial_right {
      width: 100%;
    }
    .tutorial_title {
      font-size: 0.24rem;
      line-height: 0.3rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tutorial.vue